/**
 * VueHttpPlugin
 * Vue plugin as a wraper for AXIOS
 * Author: Paul marti
 * Email: pablo@intermediatica.net
 *
 * Note:
 * This specific version requires Vuex and Buefy plugins installed BEFORE.
 */

import axios from 'axios/dist/axios';
import { debounce } from 'lodash-es';

let VueHttpPlugin = {};

VueHttpPlugin.install = (Vue, options) => {
  let Toast = Vue.prototype.$toast;

  let no_internet = debounce(
    () => Toast('error', 'No se puede conectar con el servidor'),
    250
  );
  let auth_required = debounce(
    () => Toast('error', 'Se requiere autenticación'),
    500
  );
  let custom_error_msg = debounce(
    (error_msg) => Toast('error', error_msg),
    500
  );

  let handleSuccess = (response) => {
    return response;
  };

  let handleError = (error) => {

    let error_msg = '';

    if (error.response.data)
            if (error.response.data.error)
              error_msg = error.response.data.error;

    // Handle responses out of the range of 2xx
    if (error.response) {
      switch (error.response.status) {
        case 401:
        case 403:
        case 419:
          auth_required();
          Vue.prototype.$storage.remove('api_token');
          window.location.replace('/#/login');
          break;

        case 404:
          Toast('error', 'El servidor respondió con un código 404');
          break;

        case 409:
          // Default error msg.
          error_msg = (error_msg.length) ? error_msg : 'No se puede realizar la petición, porque ya existe un registro similar o bien porque la información no es correcta.';

          custom_error_msg(error_msg);

          break;

        default:
          Toast('error', 'El servidor respondió con un código 500');
          break;
      }
    }

    // Case: no response was received
    else if (error.request) {
      no_internet();
    }

    // the request itself triggered an Error
    else {
      Vue.prototype.$toast('error', 'Error en la petición al servidor');
    }

    // this.removeLoadingState()

    return error;

  };

  axios.interceptors.response.use(handleSuccess, handleError);    

  Vue.prototype.$http = {
    get(route, callback) {
      this.setLoadingState();
      return axios.get(route, {
        headers: {
          Authorization: `Bearer ${JSON.parse(localStorage.getItem('api_token'))}`
        }
      }).then((response) => {
        this.removeLoadingState();
        return callback(response);
      });
    },

    post(route, payload, callback) {
      this.setLoadingState();
      return axios.post(route, payload, {
        headers: {
          Authorization: `Bearer ${JSON.parse(localStorage.getItem('api_token'))}`
        }
      }).then((response) => {
        this.removeLoadingState();
        return callback(response);
      });
    },

    upload(route, formData, callback) {
      this.setLoadingState();
      return axios
        .post(route, formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
            Authorization: `Bearer ${JSON.parse(localStorage.getItem('api_token'))}`
          },
        })
        .then((response) => {
          this.removeLoadingState();
          return callback(response);
        });
    },

    redirectTo: function (route) {
      document.location = route;
    },

    setLoadingState: function () {
      // Vue.prototype.$store.commit('loadingUp');
    },

    removeLoadingState: function () {
      // Vue.prototype.$store.commit('loadingDown');
    },
  };
};

export default VueHttpPlugin;
